import { Link, useRouterState } from '@tanstack/react-router';
import { Calendar, Gift, Heart, Home, User } from 'lucide-react';

import { cn } from '@/lib/utils';

interface NavItem {
  label: string;
  icon: React.ElementType;
  to: string;
  tourId: string;
}

const navItems: NavItem[] = [
  { label: 'Home', icon: Home, to: '/home', tourId: 'home' },
  { label: 'Lista', icon: Heart, to: '/wishlist/me', tourId: 'my-wishlist' },
  {
    label: 'Ocasiões',
    icon: Calendar,
    to: '/occasions/me',
    tourId: 'occasions',
  },
  {
    label: 'Parceiro',
    icon: Gift,
    to: '/wishlist/partner',
    tourId: 'partner-wishlist',
  },
  { label: 'Conta', icon: User, to: '/account', tourId: 'account' },
];

export function BottomNav() {
  const routerState = useRouterState();
  const currentPath = routerState.location.pathname;

  return (
    <nav className="bg-background border-border/40 fixed right-0 bottom-0 left-0 z-50 border-t md:hidden">
      <div className="flex h-16 items-center justify-around">
        {navItems.map((item) => {
          const isActive = currentPath.startsWith(item.to);
          const Icon = item.icon;

          return (
            <Link
              key={item.to}
              to={item.to}
              data-tour={item.tourId}
              className={cn(
                'flex flex-1 flex-col items-center justify-center gap-1 py-2 text-xs transition-colors',
                isActive
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground',
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="truncate px-1">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
